export default "../images/stackloans-partners-with-BestEgg_PORTAL_US.png?35eed08351711bfd15308c758c5a46db";